import Vue from 'vue';


export default {
  state: {},
  actions: {
    // 问题类型
    questionTypeClientInfo(ctx, params){
      return Vue.http.post('/client/questionManage/questionType-client-info', params)
    },
    // 常见问题列表
    questionClientInfo(ctx, params){
      return Vue.http.post('/client/questionManage/question-client-info', params)
    },
    // 问题详情（需要登录）
    questionClientDetails(ctx, params){
      return Vue.http.post('/client/questionManage/question-client-details', params)
    },
    // 问题是否有用反馈
    questionClientFeedback(ctx, params){
      return Vue.http.post('/client/questionManage/question-client-feedback', params)
    }
  },
  mutations: {},
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/questionManage.js